import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from '../../_services/config.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-is-deconnectd',
    templateUrl: './is-deconnectd.component.html',
    styleUrl: './is-deconnectd.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IsDeconnectdComponent implements OnInit {

  constructor(
    private router:Router,
  ){
    
  }

  ngOnInit(): void {

  }

  connect(){
    this.router.navigateByUrl('/chat')
  }

}
